import { render, staticRenderFns } from "./StopServiceLogin.vue?vue&type=template&id=bb162998&scoped=true&"
import script from "./StopServiceLogin.vue?vue&type=script&lang=js&"
export * from "./StopServiceLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb162998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb162998')) {
      api.createRecord('bb162998', component.options)
    } else {
      api.reload('bb162998', component.options)
    }
    module.hot.accept("./StopServiceLogin.vue?vue&type=template&id=bb162998&scoped=true&", function () {
      api.rerender('bb162998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/stopservice/StopServiceLogin.vue"
export default component.exports